module.exports = __webpack_public_path__ + "static/media/b4.0b5cc48d.png";